export function hubBaseRoute($urlRouterProvider, $stateProvider) {
	'ngInject';
	// default URL
	$urlRouterProvider.when('', '/login');
	$urlRouterProvider.when('/', '/login');
	$urlRouterProvider.otherwise('/404');
	// base route for ui-router
	$stateProvider.state('hub', {
		abstract: true,
		template: '<sh-impersonation-bar></sh-impersonation-bar><div ui-view></div>',
	});
}
